import { useNavigate } from "react-router-dom";
import AnalyticsService from "data/firestore/analytics";

function useCustomNavigation() {
  const theirNavigate = useNavigate();

  const navigate = (
    path: string,
    appendage: string = "",
    replace: boolean = false
  ): void => {
    // Navigate to the specified path
    theirNavigate(`/${path}${appendage}`, { replace: replace });
    if (!replace) {
      AnalyticsService.pageView();
    }
  };

  return navigate;
}

export default useCustomNavigation;
